import React from 'react'
import defaultLogo from '../../../assets/images/jumbo-ahora-logo.svg'
import retiroEnTienda from '../../../assets/images/retiro-en-tienda.svg'
import despachoADomicilio from '../../../assets/images/despacho-a-domicilio.svg'
import retiroAlAuto from '../../../assets/images/retiro-al-auto.svg'

const AppImage = ({ name, ...props }) => {
  const images = { defaultLogo, retiroEnTienda, despachoADomicilio, retiroAlAuto }
  return (
    <img src={images[name] || defaultLogo} {...props} />
  )
}

export default AppImage
